// utils/userKey.js
import { v4 as uuidv4 } from 'uuid';

const USER_KEY_COOKIE_NAME = 'datavault_kg_user_key';

function getCookie(name) {
  const match = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`));
  return match ? match.split('=')[1] : null;
}

function setCookie(name, value) {
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 2); // 2 year
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

export function getUserKey() {
  let userKey = getCookie(USER_KEY_COOKIE_NAME);

  if (!userKey) {
    userKey = uuidv4();
    setCookie(USER_KEY_COOKIE_NAME, userKey);
  }

  return userKey;
}